import React from 'react';
import { motion } from 'framer-motion';

const OfficialPoster = ({ language }) => {
  const content = {
    fr: {
      title: "Affiche Officielle",
      subtitle: "Découvrez l'affiche du concert"
    },
    en: {
      title: "Official Poster",
      subtitle: "Discover the concert poster"
    }
  };

  const text = content[language];
  
  // Choisir l'affiche selon la langue
  const posterImage = language === 'fr' ? '/images/PosterFrench.jpg' : '/images/Posterenglish.jpg';

  return (
    <div className="max-w-4xl mx-auto relative">
      {/* Glow effect */}
      <div className="absolute -inset-1 bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 rounded-3xl blur-xl opacity-30"></div>
      
      <div className="relative bg-white rounded-3xl shadow-2xl p-8 md:p-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-10"
        >
          <h2 className="text-4xl md:text-6xl font-black bg-gradient-to-r from-navy via-blue-700 to-purple-700 bg-clip-text text-transparent mb-4">
            {text.title}
          </h2>
          <p className="text-lg md:text-xl text-navy/70 font-semibold">
            {text.subtitle}
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
          className="flex justify-center"
        >
          <motion.div
            whileHover={{ scale: 1.02, y: -5 }}
            transition={{ type: "spring", stiffness: 300 }}
            className="w-full max-w-2xl relative group"
          >
            {/* Image glow */}
            <div className="absolute -inset-2 bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 rounded-2xl blur-xl opacity-40 group-hover:opacity-70 transition duration-500"></div>
            
            <motion.img
              key={posterImage}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
              src={posterImage}
              alt="Affiche officielle du concert de Charlotte Dipanda"
              className="relative w-full h-auto rounded-2xl shadow-2xl group-hover:shadow-3xl transition-shadow duration-300 border-4 border-white"
            />
            
            {/* Corner decorations */}
            <div className="absolute -top-3 -left-3 w-8 h-8 border-t-4 border-l-4 border-blue-600 rounded-tl-lg"></div>
            <div className="absolute -top-3 -right-3 w-8 h-8 border-t-4 border-r-4 border-purple-600 rounded-tr-lg"></div>
            <div className="absolute -bottom-3 -left-3 w-8 h-8 border-b-4 border-l-4 border-purple-600 rounded-bl-lg"></div>
            <div className="absolute -bottom-3 -right-3 w-8 h-8 border-b-4 border-r-4 border-pink-600 rounded-br-lg"></div>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default OfficialPoster;
